import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UserDetailsResponse } from '@edtech-ui/core/models/admin-student-platform/admin-details';
import { ResumeStepValidatable } from '@edtech-ui/core/models/resume-builder/step-validators';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ResumeService } from '@edtech-ui/core/services/resume-service/resume.service';
import { alphabetsOnlyValidator, githubValidator, linkedInValidator, locationValidator } from '@edtech-ui/core/utils/resume-validation/resume-validation-personal';
import { catchError, of, tap } from 'rxjs';

@Component({
	selector: 'app-resumer-builder-personal',
	standalone: true,
	imports: [ReactiveFormsModule, CommonModule],
	templateUrl: './resumer-builder-personal.component.html',
	styleUrl: './resumer-builder-personal.component.scss'
})
export class ResumerBuilderPersonalComponent implements OnInit, ResumeStepValidatable {

	userProfileForm: FormGroup;
	userId: string = '';
	private isPrefilled = false;

	constructor(
		private resumeService: ResumeService,
		private route: ActivatedRoute,
		private _authService: AuthServiceService
	) {

		this.userProfileForm = new FormGroup({
			fullName: new FormControl('', [Validators.required, alphabetsOnlyValidator]),
			email: new FormControl('', [Validators.required, Validators.email]),
			phone: new FormControl('', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]),
			location: new FormControl('', [locationValidator]),
			linkedinUrl: new FormControl(''),
			githubUrl: new FormControl(''),

		});
	}

	ngOnInit(): void {
		const resumeId = this.route.snapshot.paramMap.get('resumeId');
		this.userId = localStorage.getItem('user_id') || '';
		if (resumeId) {
			this.resumeService.getFullResumeData().subscribe(data => {
				if (data?.personal_info) {
					this.editPersonalData(data.personal_info);
				}
			});
		} else {
			const data = this.resumeService.getSectionData('personal_info');
			if (data) {
				this.userProfileForm.patchValue(data);
			}
		}
		this.getUsers();
	}

	saveData() {

		if (this.userProfileForm.invalid) {
			this.userProfileForm.markAllAsTouched();
			return false;
		}

		const payload = this.userProfileForm.value;
		this.resumeService.setSectionData('personal_info', payload);
		return true;
	}

	editPersonalData(data: any) {
		this.userProfileForm.patchValue({
			fullName: data.fullName || '',
			email: data.email || '',
			phone: data.phone || '',
			location: data.location || '',
			linkedinUrl: data.linkedinUrl || '',
			githubUrl: data.githubUrl || ''
		});
	}

	
	isFormValid(): boolean {
		return this.userProfileForm.valid;
	}


	getUsers() {
		if (!this.userId) return;

		this._authService.getUserDetails(this.userId).pipe(
			tap((response: UserDetailsResponse) => {

				if (response.Success && response.Data) {

					const api = response.Data;
					const form = this.userProfileForm.value;

					this.userProfileForm.patchValue({
						fullName: form.fullName || `${api.first_name || ''} ${api.last_name || ''}` || null,
						email: form.email || api.phone_email || null,
						phone: form.phone || api.phone_number || null,
						location: form.location || api.city || null,
						linkedinUrl: form.linkedinUrl || null,
						githubUrl: form.githubUrl || null
					});
				}
			}),
			catchError(() => of(null))
		).subscribe();
	}


}